import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';
import { TiendasComponent } from './tiendas/tiendas.component';
import { WayfindingComponent } from './wayfinding/wayfinding.component';
import { IndexComponent } from './index/index.component';
import { ServiciosComponent } from './servicios/servicios.component';
import { OfertasComponent } from './ofertas/ofertas.component';
import { EventosComponent } from './eventos/eventos.component';
import { EventoSelComponent } from './evento-sel/evento-sel.component';
import { TestkeyboardComponent } from './testkeyboard/testkeyboard.component';
import { TiendaSelecComponent } from './tienda-selec/tienda-selec.component';
import {BuscarComponent} from './buscar/buscar.component';
import { InformacionComponent } from './informacion/informacion.component';
import { CineComponent } from './cine/cine.component';
import { PeliculaComponent} from './pelicula/pelicula.component';
import { EnviarrutaComponent } from './enviarruta/enviarruta.component' 
import { EstacionamientosComponent} from './estacionamientos/estacionamientos.component';
import { ZonasinteresComponent } from './zonasinteres/zonasinteres.component';
import { ZonagourmetComponent } from './zonagourmet/zonagourmet.component';
import { PatiodecomidaComponent } from './patiodecomida/patiodecomida.component';
declare const componentHandler: any;

const routes: Routes = [
  { path: '', component: IndexComponent },
  { path: 'tiendas', component: TiendasComponent },
  { path: 'index', component: IndexComponent},
  { path: 'servicios', component: ServiciosComponent},
  { path: 'servicios/:id', component: ServiciosComponent},
  { path: 'ofertas' , component: OfertasComponent},
  { path: 'eventos' , component: EventosComponent},
  { path: 'eventosel/:id' , component: EventoSelComponent},
  { path: 'test' , component: TestkeyboardComponent},
  { path: 'tiendas/:tipo/:id' , component: TiendaSelecComponent},
  { path: 'buscar' , component: BuscarComponent},
  { path: 'cine' , component: CineComponent},
  { path: 'pelicula/:id' , component: PeliculaComponent},
  { path: 'informacion' , component: InformacionComponent},
  { path: 'estacionemientos' , component: EstacionamientosComponent},
  { path: 'enviarruta/:tipo/:id/:transs' , component: EnviarrutaComponent},
  { path: 'zonainteres/:id' , component: ZonasinteresComponent},
  { path: 'zonagourmet' , component: ZonagourmetComponent},
  { path: 'patiodecomida' , component: PatiodecomidaComponent},
  { path: 'wayfinding/:id', component: WayfindingComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

  constructor(private router: Router) {
    router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // Para que los componentes de MDL se 'refresquen'
        //componentHandler.upgradeAllRegistered();

      }
    });
  }

}
